import API from "../../restAPI";
const Api = new API();

export default class UploadsAPI {  
  // get total user count for user report
  uploadImages(payload, clientId) {
    return Api.request("/buckets/upload/"+clientId, payload, "POST");
  }
}
